<div class="cgu-token">
  <div class="cgu-token-container container">
    <div class="description-block">
      <div class="description-title">
        CGU TOKEN
      </div>
      <p class="description">The CGU token is the native currency and fuel of the CGU DAO. CGU is distributed for
        completing tasks that are beneficial for the community, as bonuses for exceeding targets, and as staking
        rewards.
        The token can be used to buy services within the DAO, as well as voting on different proposals to determine
        future
        priorities and initiatives.
      </p>
    </div>
    <div class="left-block">
      <div class="header">
        <img src="/static/images/cgu-token/cgu-token.9c0a7089.svg" alt="CGU token logo">
      </div>
      <div class="metrics">
        <div class="metrics-numbers-block">
          <div class="metric price">
            <div class="name">Price provided by <a href="https://timex.io/" class="price-timex">TimeX.io</a></div>
            <div class="value">
          <span>
            ${{ price }}
          </span>
            </div>
          </div>
          <div class="metric market-cap">
            <div class="name">Market Cap:</div>
            <div class="value">
          <span>
            ${{ marketCap }}
          </span>
            </div>
          </div>
          <div class="metric price">
            <div class="name">Total Supply:</div>
            <div class="value">1,000,000,000</div>
          </div>
        </div>
        <div class="contract-address">
          <a href="https://bscscan.com/token/0x747d74db20cc422f39ab54edb2a3ce21f3c98af1" target="_blank">0x747d74db2...f3c98af1</a>
          <img class="copy-button" width="16" height="16" src="/static/images/copy.png" alt="Copy button"
               @click="copyAddress">
        </div>
      </div>
    </div>
  </div>
  <div class="cgu-token-container container">
    <div class="available-token-description">
      <span>Available markets:</span>
      <span class="all-markets-on">All markets on
        <a href="https://coinmarketcap.com/currencies/crypto-gaming-united/markets/"
           class="coin-market-cap">CoinMarketCap</a>
      </span>
      <a href="https://timex.io/private/trading/cguusdt" target="_blank" class="btn button-buy-cgu">
        <span class="btn-content">Buy CGU</span>
      </a>
    </div>
    <div class="exchanges">
      <div class="exchanges-markets">
        <a href="https://timex.io/private/trading/cguusdt" class="exchange" target="_blank" title="TimeX">
          <img src="/static/images/logo/timex.svg" alt="TimeX"/>
        </a>
        <a href="https://pancakeswap.finance/swap?outputCurrency=0x747D74dB20cc422F39ab54EDB2A3Ce21f3C98AF1"
           class="exchange" target="_blank" title="PancakeSwap">
          <img src="/static/images/logo/pancake-1x.png" srcset="/static/images/logo/pancake-2x.png 2x" alt="Pancake"/>
        </a>
        <a href="https://www.probit.com/app/exchange/CGU-USDT" class="exchange" target="_blank" title="ProBit">
          <img src="/static/images/logo/probit.png" alt="probit"/>
        </a>
        <a href="https://www.bitrue.com/trade/cgu_usdt" class="exchange" target="_blank" title="BitTrue">
          <img src="/static/images/logo/bittrue.png" alt="BitTrue"/>
        </a>
      </div>
    </div>
  </div>
</div>
